import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c(VMenu, {
    attrs: {
      top: "",
      "offset-y": "",
      "open-on-hover": "",
      disabled: !_vm.payments.length
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_vm.state && _vm.paymentState ? _c("div", _vm._g(_vm._b({
          staticClass: "badge",
          class: [[_vm.stateStyleClass()[_vm.state]]]
        }, "div", attrs, false), on), [_c("span", {
          staticClass: "mr-1"
        }, [_vm._v("Payment")]), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("span", [_vm._v("Needs support review")]) : _c("span", [_vm._v(_vm._s(_vm.isStateShown ? _vm.state : "") + " " + _vm._s(!_vm.isStateShown ? _vm.suffix : ""))]), [_vm.state === _vm.paymentState.SUCCEEDED ? [_c("i", {
          staticClass: "fas fa-check"
        }), !!_vm.date ? _c("span", [_vm._v("  " + _vm._s(_vm._f("formatDate")(_vm.date)))]) : _vm._e()] : _vm._e(), _vm.state === _vm.paymentState.PROCESSING ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.ACKNOWLEDGED ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.DEFERRED ? _c("i", {
          staticClass: "fas fa-clock"
        }) : _vm._e(), _vm.state === _vm.paymentState.FAILED ? _c("i", {
          staticClass: "fas fa-times"
        }) : _vm._e()]], 2) : _vm._e()];
      }
    }])
  }, [_c(VList, {
    staticClass: "hover-tooltip payment-list"
  }, _vm._l(_vm.payments, function (item, index) {
    var _item$typeLabel;
    return _c(VListItem, {
      key: index
    }, [_c(VListItemTitle, [index !== 0 ? _c(VDivider, {
      staticClass: "item-divider"
    }) : _vm._e(), !!item.typeLabel ? _c("div", [_c("div", [_c("i", {
      staticClass: "fas fa-receipt"
    }), _vm._v(" " + _vm._s((_item$typeLabel = item.typeLabel) !== null && _item$typeLabel !== void 0 ? _item$typeLabel : "No payment method") + " ")])]) : _vm._e(), _c("span", [_vm._v("Payment")]), !item.state || item.state === _vm.paymentState.ACKNOWLEDGED ? _c("span", [_vm._v(" needs support review ")]) : _c("span", [_vm._v(" " + _vm._s(item.state !== _vm.paymentState.DEFERRED ? _vm.state : "") + " " + _vm._s(item.state === _vm.paymentState.DEFERRED ? _vm.suffix : "") + " ")]), [item.state === _vm.paymentState.SUCCEEDED ? [_c("i", {
      staticClass: "fas fa-check"
    }), !!item.paymentDate ? _c("span", [_vm._v("  " + _vm._s(_vm._f("formatDate")(item.paymentDate)))]) : _vm._e()] : _vm._e(), item.state === _vm.paymentState.PROCESSING ? _c("i", {
      staticClass: "fas fa-clock"
    }) : _vm._e(), item.state === _vm.paymentState.ACKNOWLEDGED ? _c("i", {
      staticClass: "fas fa-clock"
    }) : _vm._e(), item.state === _vm.paymentState.DEFERRED ? _c("i", {
      staticClass: "fas fa-clock"
    }) : _vm._e(), item.state === _vm.paymentState.FAILED ? _c("i", {
      staticClass: "fas fa-times"
    }) : _vm._e(), item.reference ? _c("span", {
      staticClass: "ml-2"
    }, [_vm._v("#" + _vm._s(item.reference))]) : _vm._e()], !!item.microDepositsUrl ? _c("div", {
      staticClass: "micro-deposits"
    }, [_c("div", {
      staticClass: "title-small"
    }, [_c("i", {
      staticClass: "fas fa-money-check-alt font-sm"
    }), _vm._v(" Micro-deposits link ")]), _c("a", {
      staticClass: "micro-deposits-url",
      attrs: {
        href: item.microDepositsUrl,
        target: "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.microDepositsUrl) + " ")])]) : _vm._e()], 2)], 1);
  }), 1)], 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };